/**
 * Asset reservation status values
 */
export enum AssetReservationStatusEnum {
	/**
	 * Asset reservation is pending
	 */
	PENDING = 'pending',
	/**
	 * Asset reservation is accepted
	 */
	ACCEPTED = 'accepted',
	/**
	 * Asset reservation is rejected
	 */
	REJECTED = 'rejected',
	/**
	 * Asset reservation is cancelled
	 */
	CANCELLED = 'cancelled',
}
